import { Login } from '@/controllers/uiController'
import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import emitter, { EmitterEvents } from '@/helpers/emitter'
// import { envHelper } from '@/helpers/envHelper'
import { userService } from '@/services/userService'
import { action, computed, makeAutoObservable, observable } from 'mobx'

export class GoodsDetailState {
  @observable
  detail?: ServerData.PptInfoData
  @observable
  materialId: number = 0

  @observable
  loading = true
  @observable downing = false

  @observable
  activeTab = 'detail'
  tabs = [
    { label: '详情', key: 'detail' },
    { label: '预览', key: 'preview' },
  ] as const

  /** 是否直接下载 */
  @computed
  get isDirectDownload() {
    return (
      this.detail?.downloadInfo?.hasSingleBuy === true ||
      this.buyDownCount > 0 ||
      this.detail?.planData?.price === 0
    )
  }

  /** 总下载次数 含兑换码下载次数  */
  @computed
  get allDownCount() {
    const { exchangeCodeRemeDownloadCount } = this.detail?.downloadInfo ?? {}
    return (exchangeCodeRemeDownloadCount ?? 0) + this.buyDownCount
  }

  /** 购买下载次数 */
  @computed
  get buyDownCount() {
    const { vipRemeDownloadCount, singleRemeDownloadCount } = this.detail?.downloadInfo ?? {}
    return Math.max(0, vipRemeDownloadCount ?? 0) + Math.max(0, singleRemeDownloadCount ?? 0)
  }

  @computed
  get showDownLoadBtn() {
    return (
      this.allDownCount > 0 || this.detail?.downloadInfo?.hasSingleBuy === true || userService.isVip
    )
  }

  constructor() {
    makeAutoObservable(this)
    emitter.on(EmitterEvents.PAY_SUCCESS, () => {
      this.getInfo(false)
    })
  }

  @action
  async getInfo(loading: boolean = true) {
    this.loading = loading
    const id = this.materialId
    const res = await api.ppt.getPptInfo(id)
    if (id !== this.materialId) {
      return
    }
    this.detail = res.data
    this.loading = false
  }

  @action
  async setMaterialId(materialId: number) {
    if (materialId !== this.materialId) {
      this.detail = undefined
    }
    this.materialId = materialId
    await this.getInfo()
  }

  @action
  async setActiveTab(activeTab: 'detail' | 'preview') {
    this.activeTab = activeTab
  }

  @Login()
  async download() {
    if (this.downing) {
      return
    }
    this.downing = true
    return api.ppt
      .getPptDownload(this.detail?.id ?? 0)
      .then((res) => {
        if (res.data?.url) {
          // const url = res.data.url
          // var downloadUrl =
          //   url + (url.indexOf('?') > -1 ? '&' : '?') + 'response-content-disposition=attachment' // 补充强制下载的参数
          // downloadUrl += `;filename*=UTF-8''${this.detail?.name}.${this.detail?.fileType}`

          // if (commonUtils.isWechat()) {
          //   // const key = new URL(url).pathname.split('/').reverse()[0]
          //   // const newurl =
          //   //   'https://d.1yb.co/business/material_center/assets/' +
          //   //   key +
          //   //   `?response-content-disposition=attachment;filename=${this.detail?.name}.${this.detail?.fileType}`
          //   // commonUtils.downloadFile(newurl)
          //   commonUtils.downloadFile(
          //     envHelper.webHost! +
          //       envHelper.apiBasePath! +
          //       '/material/download_file?url=' +
          //       encodeURIComponent(res.data.url)
          //   )
          // } else {
          commonUtils.downloadFile(res.data.url)
          // }
        }
      })
      .finally(() => {
        this.getInfo(false)
        setTimeout(() => {
          this.downing = false
        }, 500)
      })
  }
}

const goodsDetailState = new GoodsDetailState()

export default goodsDetailState
